export const EASE = [0.6, -0.05, 0.01, 0.99] as const;
